<template>
  <v-container fluid class="mx-0 px-0" @keydown.enter="submit()">
    <template v-if="showError">
      <v-row>
        <v-col cols="12">
          <v-alert dense outlined type="error" class="my-0">
            <span v-html="errorMessage"></span>
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="5" v-if="showPaieska">
        <el-autocomplete
          :min-width="500"
          :items="tipasItems"
          itemvalue="value"
          itemtext="text"
          label="Dokumento tipas"
          tooltip="Modalas asmuo. Dokumento tipas"
          v-model="dokTipas"
          autofocus
          @click="focusDokNumeris"
          @focus="focusDokNumeris"
          @blur="blurDokNumeris"
        />
      </v-col>
      <v-col cols="4" v-if="showPaieska">
        <el-text-field
          label="Dokumento numeris"
          tooltip="Modalas asmuo. Dokumento numeris"
          v-model="dokNumeris"
          @focus="focusDokNumeris"
          @blur="blurDokNumeris"
        />
      </v-col>
      <v-col cols="3" class="text-right" v-if="showPaieska">
        <el-button
          class="mt-4"
          primary
          @click.native="checkDokumentasRegistras()"
          :loading="loading"
          :disabled="disabledIeskoti"
          small
        >
          Tikrinti registre
        </el-button>
      </v-col>

      <v-col cols="12">
        <el-textarea
          label="Dokumentas"
          v-model="dokumentas"
          :readonly="dokumentasReadonly"
          counter="1000"
          :append-outer-icon="showPaieska ? 'mdi-delete' : ''"
          @clickAppendOuter="deleteDokumentas()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
export default {
  name: 'ElAsmuoDokumentas',
  mixins: [userRole],
  props: {
    value: String,
    readonly: Boolean,
    asmKodas: String,
    foreign: Boolean,
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      dokTipai: [],
      dokTipas: null,
      dokNumeris: null,
      loadingRegistras: false,
      showError: false,
      errorMessage: null,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'appSavitarna']),
    dokumentas: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    isSavitarna() {
      return this.appSavitarna
    },
    showPaieska() {
      return (
        !this.readonly &&
        !this.foreign &&
        this.roleOr(['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'])
      )
    },
    tipasItems() {
      return this.dokTipai.map(item => {
        return item
      })
    },
    disabledIeskoti() {
      return !this.dokTipas || !this.dokNumeris
    },
    dokumentasReadonly() {
      return this.readonly || !this.foreign
    },
  },
  created() {
    this.getKlasif()
  },
  methods: {
    resetError() {
      this.errorMessage = null
      this.showError = false
    },
    getKlasif() {
      const data = {
        klasifikatoriai: ['asmens_dokumento_tipai'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.dokTipai = res.data.list.asmens_dokumento_tipai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    checkDokumentasRegistras() {
      this.loading = true
      this.resetError()

      const data = {
        obj_id: this.objektasID,
        asm_kodas: this.asmKodas,
        dok_tipas: this.dokTipas,
        dok_numeris: this.dokNumeris,
      }

      this.$axios
        .post(`asmens-dokumentas/search`, data)
        .then(res => {
          this.dokumentas = res.data.dokumentas
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.errorMessage = err.response.data.message
            this.showError = true
            return
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteDokumentas() {
      this.dokumentas = null
    },
    submit() {
      if (!this.loading && !this.disabledIeskoti) {
        this.checkDokumentasRegistras()
      }
    },
    focusDokNumeris() {
      this.$emit('disableSave', true)
    },
    blurDokNumeris() {
      this.$emit('disableSave', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
